module.exports = __webpack_public_path__ + "img/swear.580ee314.gif";